module.exports = __webpack_public_path__ + "img/充电桩.2b75604b.png";